module.exports = __webpack_public_path__ + "img/Cadeira1.7774165c.webp";